import flagKeys from '@/constants/flagKeys';
import { Route } from '../route.model';

const ChangePassword = () => import('@/views/Settings/ChangePassword.vue');

const changePassword = new Route(
  '/settings/password',
  'settings_password',
  ChangePassword,
  {
    requiresAuth: true,
    isResponsive: flagKeys.responsiveDashboard,
    zendesk: {
      mobile: {
        offsetVertical: '4px',
        offsetHorizontal: '4px'
      }
    },
    navbar: {
      name: 'Password',
      icon: 'lock'
    },
    pageView: {
      eventLabel: 'Password'
    }
  }
);

export { changePassword };
export default changePassword;
